import React from 'react'

import Icon from './Icon'
import type { IconProps } from './Icon'
import { ReactComponent as Clock } from 'assets/svg/icon-clock.svg'

function IconClock(props: IconProps): JSX.Element {
  const title = 'icon-clock'
  const {
    className,
    id = title,
    name = title,
    variants = 'md',
    ...others
  } = props

  const svgProps = { id, name }

  return (
    <Icon className={className} variants={variants} {...others}>
      <Clock {...svgProps} data-testid={title} />
    </Icon>
  )
}

export default IconClock
